export default {
  seats: [],
};
